'use strict';

var define = require('define-properties');

var implementation = require('./implementation');
var getPolyfill = require('./polyfill');
var shim = require('./shim');

/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */

define(implementation, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = implementation;



//////////////////
// WEBPACK FOOTER
// ./~/is-nan/index.js
// module id = 149
// module chunks = 22433821621997 31167082146650 235131596041995